export default "__VITE_ASSET__DsGxC6ti__"